
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { formatDateTime } from "@/utils/dateUtils";

type DiagramsListProps = {
  diagrams: Array<{
    created_at: string;
    diagram: {
      id: string;
      name: string;
    };
  }> | undefined;
};

export const DiagramsList = ({ diagrams }: DiagramsListProps) => {
  return (
    <Card className="border border-border/40 shadow-sm">
      <CardContent className="p-6">
        <h3 className="text-xl font-semibold mb-4 text-foreground">Diagramas que utilizam este componente</h3>
        <Table>
          <TableHeader>
            <TableRow className="bg-primary/5 hover:bg-primary/10">
              <TableHead className="text-primary font-medium">Nome do Diagrama</TableHead>
              <TableHead className="text-primary font-medium">Data de Inclusão</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {diagrams?.length ? (
              diagrams.map((item, index) => (
                <TableRow key={index} className="hover:bg-muted/50">
                  <TableCell className="text-foreground">{item.diagram.name}</TableCell>
                  <TableCell className="text-foreground">{formatDateTime(item.created_at)}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={2} className="text-center py-8">
                  <p className="text-sm text-muted-foreground">Nenhum diagrama encontrado.</p>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
